import {useCallback} from 'react';
import useAxios from '@Apis/useAxios';
import {
    GET_ORDER_RETURS_ALLOWANCE_DIALOG_API,
    POST_ORDER_RETURN_ALLOWANCE_CONFIRM_API,
    GET_ORDER_RETURN_INVALID_DIALOG_API,
    POST_ORDER_RETURN_INVALID_CONFIRM_API,
    POST_ORDER_RETURN_INVALID_AGAIN_API,
    GET_ORDER_RETURN_ALLOWANCE_HISTORY_API,
    POST_ORDER_RETURN_INVALID_ALLOWANCE_CONFIRM_API
} from '@Apis/apiPath';

const useOrderReturnApi = () => {
    const Axios = useAxios();

    const getOrderReturnAllowanceDialogApi = useCallback(async (orderID) => {
            return await Axios.get(GET_ORDER_RETURS_ALLOWANCE_DIALOG_API(orderID));
        },
        // eslint-disable-next-line
        []);

    const postOrderReturnAllowanceConfirmApi = useCallback(async (params) => {
            return await Axios.post(POST_ORDER_RETURN_ALLOWANCE_CONFIRM_API, params);
        },
        // eslint-disable-next-line
        []);

    const getOrderReturnInvalidDialogApi = useCallback(async (orderID) => {
            return await Axios.get(GET_ORDER_RETURN_INVALID_DIALOG_API(orderID));
        },
        // eslint-disable-next-line
        []);

    const postOrderReturnInvalidConfirmApi = useCallback(async (params) => {
            return await Axios.post(POST_ORDER_RETURN_INVALID_CONFIRM_API, params);
        },
        // eslint-disable-next-line
        []);

    const postOrderReturnInvalidAgainApi = useCallback(async (returnID, params) => {
            return await Axios.post(POST_ORDER_RETURN_INVALID_AGAIN_API(returnID), params);
        },
        // eslint-disable-next-line
        []);

    const getOrderReturnAllowanceHistoryApi = useCallback(async (orderID) => {
            return await Axios.get(GET_ORDER_RETURN_ALLOWANCE_HISTORY_API(orderID));
        },
        // eslint-disable-next-line
        []);

    const postOrderReturnInvalidAllowanceConfirmApi = useCallback(async (params) => {
            return await Axios.post(POST_ORDER_RETURN_INVALID_ALLOWANCE_CONFIRM_API, params);
        },
        // eslint-disable-next-line
        []);

    return {
        getOrderReturnAllowanceDialogApi,
        postOrderReturnAllowanceConfirmApi,
        getOrderReturnInvalidDialogApi,
        postOrderReturnInvalidConfirmApi,
        postOrderReturnInvalidAgainApi,
        getOrderReturnAllowanceHistoryApi,
        postOrderReturnInvalidAllowanceConfirmApi
    };
};

export default useOrderReturnApi;
